export default "__VITE_ASSET__5KjTPbDt__"